import { Root } from '../vendor/mui-devias-kit/root';
import RootNavigator from './RootNavigator';
import configureStore from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { SustainApiReadConfig } from './api';

const { persistor } = configureStore();

export default function App() {
  return (
    <Root>
      <PersistGate loading={null} persistor={persistor}>
        <SustainApiReadConfig>
          <RootNavigator />
        </SustainApiReadConfig>
      </PersistGate>
    </Root>
  );
}
